import { useEffect, useState } from "react";
import { useWindowSizes } from "./useWindowSizes";

const PHONE_WIDTH = 480;
export const TABLET_WIDTH = 800;

export const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState<string>("desktop");
  const windowSize = useWindowSizes();

  useEffect(() => {
    if (windowSize.width <= PHONE_WIDTH) {
      setDeviceType("phone");
    } else if (windowSize.width <= TABLET_WIDTH) {
      setDeviceType("tablet");
    } else {
      setDeviceType("desktop");
    }
  }, [windowSize.width]);

  return deviceType;
};
